(function(){

  /*
   * angular-aloe-pups
   *
   * Version: 0.0.1 - 2014-03-07
   * Create: 2014-03-07
   *
   */


  'use strict'

  angular.module('aloengular',[
    'aloengular.browserPrefix',
    'aloengular.swipe',
    'aloengular.swipeList',
    'aloengular.slider',
    'aloengular.template'
  ]);

  angular.module('aloengular.template', [
    'aloengular/template/slider/slider.html',
    'aloengular/template/slider/slide.html',
    'aloengular/template/slider/caption.html'
  ]);


  angular.module('aloengular.browserPrefix',[])
  .factory('$browserPrefix', [function () {
    var styles   = window.getComputedStyle(document.documentElement, ''),
        pre      = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) ||
                   (styles.OLink === '' && ['', 'o']))[1],
        dom      = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1],
        hasTouch = 'ontouchstart' in document.documentElement;

    return {
      dom: dom,
      lowercase: pre,
      css: '-' + pre + '-',
      js: pre[0].toUpperCase() + pre.substr(1),
      supportTouch: !!hasTouch
    }
  }]);


  angular.module('aloengular.swipe', [])
  .factory('$swipe', [ function() {

    function getCoordinates(event) {
      var touches = event.touches && event.touches.length ? event.touches : [event];
      var e = (event.changedTouches && event.changedTouches[0]) ||
          (event.originalEvent && event.originalEvent.changedTouches &&
              event.originalEvent.changedTouches[0]) ||
          touches[0].originalEvent || touches[0];

      return {
        x: e.clientX,
        y: e.clientY
      };
    }

    return {

      bind: function(element, eventHandlers) {

        var startCoords             = {},
            active                  = false,
            isVertical              = false,
            direction               = 1, //-1: left-top, 1:right-bottom
            MAX_RATIO               = 0.3,
            MAX_OTHER_AXIS_DISTANCE = 75,
            MIN_DISTANCE            = 50;

        function validSwipe(coords) {
          if (!startCoords || !active) return false;
          var deltaY = (coords.y - startCoords.y) *  direction;
          var deltaX = (coords.x - startCoords.x) * -direction;

          if (!isVertical){
            return Math.abs(deltaY) < MAX_OTHER_AXIS_DISTANCE &&
              deltaX > 0 && deltaX > MIN_DISTANCE &&
              Math.abs(deltaY) / deltaX < MAX_RATIO;
          } else {
            return Math.abs(deltaX) < MAX_OTHER_AXIS_DISTANCE &&
              deltaY > 0 && deltaY > MIN_DISTANCE &&
              Math.abs(deltaX) / deltaY < MAX_RATIO;
          }
        }

        element.on('touchstart mousedown', function(event) {
          startCoords = getCoordinates(event);
          active = true;
          isVertical = false;
          eventHandlers['start'] && eventHandlers['start'](startCoords, event);
        });

        element.on('touchcancel', function(event) {
          active = false;
          eventHandlers['cancel'] && eventHandlers['cancel'](event);
        });

        element.on('touchmove mousemove', function(event) {
          if (!active)      return;
          if (!startCoords) return;

          var coords = getCoordinates(event);
          var deltaX, deltaY, ratio;

          deltaX = Math.abs(coords.x - startCoords.x);
          deltaY = Math.abs(coords.y - startCoords.y);

          ratio = deltaY / deltaX;
          if (ratio < MAX_RATIO){
            event.preventDefault();
            isVertical = false;
          } else {
            isVertical = true;
          }

          direction = isVertical ?
                      (coords.y - startCoords.y > 0 ? -1 : 1) :
                      (coords.x - startCoords.x > 0 ? -1  : 1);

          event.isVertical = isVertical;
          event.direction = direction;

          eventHandlers['move'] && eventHandlers['move'](coords, event);
        });

        element.on('touchend mouseup', function(event) {
          if (!active) return;
          var coords = getCoordinates(event);

          event.isVertical = isVertical;
          event.isValid    = validSwipe(coords);
          event.direction  = direction;
          active = false;
          eventHandlers['end'] && eventHandlers['end'](coords, event);
        });
      }
    };
  }]);
  angular.module('aloengular.swipeList', ['aloengular.browserPrefix','aloengular.swipe'])
  .factory('$swipeList', ['$browserPrefix','$swipe','$window', function ($bP,$swipe,$w) {

    return {
      bind : function(element, eventHandlers, axis, setHeight){

        var el = element[0]     ,
                 childLen       ,
                 startCoords    ,
                 startTranslate ,
                 currentIndex   = 0,
                 _transform     = $bP.css + 'transform' ;

        axis = typeof axis == 'undefined' ? 1 : axis;
        setHeight = typeof setHeight == 'undefined' ? true : setHeight;

        $w = angular.element($w);

        var getElementSize = function(){
          return {
            width  : el.parentNode.offsetWidth,
            height : el.parentNode.offsetHeight
          }
        }

        var setElementSize = function(){
          var size = getElementSize(),x;
          el.style.width  = (axis == 1  ? size.width  * childLen : size.width)  + 'px';
          if(setHeight) el.style.height = (axis == -1 ? size.height * childLen : size.height) + 'px';

          var c = el.children;

          for(var i = 0; i < childLen, x = c[i]; i++){
            x.style.width = size.width + 'px';
            if(setHeight) x.style.height = size.height + 'px';
          }
          element.removeClass('ang-swipeList');
          setTranslate(getCurrentCoords());
          element.addClass('ang-swipeList');
        }

        var getCurrentCoords = function(){
          var size = getElementSize();
          return {
            x : axis >= 0 ? size.width  * currentIndex : 0,
            y : axis <=0  ? size.height * currentIndex : 0
          }
        }

        var setTranslate = function(coords){
          el.style['transform'] = 'translate(' + -coords.x + 'px,' + -coords.y + 'px)';
          el.style[_transform]  = 'translate(' + -coords.x + 'px,' + -coords.y + 'px)';
        }

        angular.element(document).ready(function(){
          childLen = el.children.length;
        });

        element.ready(function(e){
          setElementSize();
        });

        $w.on('resize',function(e){
          setElementSize();
        });

        $swipe.bind(element,{
          start: function(c,e){
            element.removeClass('ang-swipeList');

            startTranslate = el.style['transform'] || el.style[_transform];
            startTranslate = startTranslate.replace(/px/,'').split('(')[1].split(')')[0].split(',');

            startCoords = { x: c.x - Number(startTranslate[0]), y: c.y - Number(startTranslate[1]) };

            eventHandlers['start'] && eventHandlers['start'](c,e,currentIndex);
          },
          move: function(c,e){
            var dx = axis >= 0 ? c.x - startCoords.x : 0,
                dy = axis <= 0 ? c.y - startCoords.y : 0,
                s  = getElementSize(),px,py;

            setTranslate({ x: -dx, y: -dy });

            px = -dx % s.width * 100 / s.width;
            py = -dy % s.height * 100 / s.height;
            eventHandlers['move'] && eventHandlers['move'](c,e,currentIndex,px,py);
          },
          cancel: function(){
            element.addClass('ang-swipeList');
            setTranslate(getCurrentCoords());
            eventHandlers['cancel'] && eventHandlers['cancel'](c,e,currentIndex);
          },
          end: function(c,e){
            element.addClass('ang-swipeList');

            var evt    = 'invalid',
                size   = getElementSize(),
                coords = getCurrentCoords(),
                idx;

            if(e.isValid){
              evt = e.isVertical ? (e.direction > 0 ? 'top' : 'bottom') : (e.direction < 0 ? 'left' : 'right');

              idx = currentIndex + e.direction;
              currentIndex = idx < 0 || idx >= childLen ? currentIndex : idx;

              coords.x = axis >= 0 ? size.width  * currentIndex: 0;
              coords.y = axis <= 0 ? size.height * currentIndex: 0;
              eventHandlers[evt] && eventHandlers[evt](c,e,currentIndex);
              evt = 'change';
            }
            eventHandlers[evt] && eventHandlers[evt](c,e,currentIndex);
            setTranslate(coords);
            eventHandlers['end'] && eventHandlers['end'](c,e,currentIndex);
          }
        });

        return {
          go : function(index){
            var index  = currentIndex = index < 0 || index >= childLen ? currentIndex : index,
                size   = getElementSize();
            setTranslate({ x : axis >= 0 ? size.width * index : 0, y : axis <=0  ? size.height * index : 0 });
          }
        }
      }
    };
  }])

  angular.module('aloengular.slider', ['aloengular.swipeList'])
  .controller('SliderCtrl', ['$rootScope', '$scope', '$element', '$attrs','$swipeList','$interval','$timeout',
    function ($r, $s, $e, $a, $swipeList,$interval,$timeout) {
      var that       = this,
          swipeArea  = angular.element($e.children()[1].children[0]),
          swipeList,
          currentSlide,
          interval,
          setInterval;

      $s.slides = [];
      $s.currentIndex = 0;
      $r.$on('aloengular:slider:selectIndex', selectIndexR);

      function selectIndexR(e,a){
         $s.select($s.slides[a]);
      }

      this.addSlide = function(slide){
        if(!$s.slides.length){
          slide.s.selected = true;
          currentSlide = slide;
        }
        $s.slides.push(slide);
      }

      $s.selectIndex = function(index){
        $s.$apply(function(){
          $s.select($s.slides[index]);
        });
      }

      $s.select = function(slide){
        angular.forEach($s.slides, function(_slide){
          _slide.s.selected = false;
        });
        slide.s.selected = true;
        $s.currentIndex = $s.slides.indexOf(slide);
        swipeList.go($s.currentIndex);
        currentSlide = slide;
        $r.$broadcast('aloengular:slider:select', { index: $s.slides.indexOf(slide), slide : slide });
      }

      $s.prev = function(){
        var i = $s.slides.indexOf(currentSlide) - 1;
        if(i >= 0)
          $s.select($s.slides[i]);
      }

      $s.next = function(){
        var i = $s.slides.indexOf(currentSlide) + 1;
        if(i < $s.slides.length)
          $s.select($s.slides[i]);
      }

      swipeList = $swipeList.bind(swipeArea,{
        start : function(){
          $interval.cancel(interval);
        },
        change : function(c,e,idx){
          $s.selectIndex(idx);
        },
        end : function(){
          interval = setInterval();
        }
      });

      setInterval = function(){
        if($s.interval > 0){
          return $interval(function(){
            var next = $s.slides.indexOf(currentSlide) + 1;
            next = next % $s.slides.length;
            $s.select($s.slides[next]);
          },$s.interval);
        }
      }

      $timeout(function(){
        interval = setInterval();
      },$s.delay);

    }
  ])
  .directive('slider', function () {
    return {
      restrict    : 'EA',
      transclude  : true,
      replace     : true,
      scope       : {
        width    : '@',
        height   : '@',
        interval : '=',
        delay    : '=',
        bullets  : '=',
        arrows   : '='
      },
      controller  : 'SliderCtrl',
      link : function(scope,element,attrs){
        attrs.width    = angular.isDefined(attrs.width)    ? attrs.width  : '100%';
        attrs.height   = angular.isDefined(attrs.height)   ? attrs.height : '400px';
        attrs.interval = angular.isDefined(attrs.interval) ? attrs.interval : 0;
        attrs.delay    = angular.isDefined(attrs.delay)    ? attrs.delay : 0;
        attrs.bullets  =  angular.isDefined(attrs.bullets) ? attrs.bullets : true;
        attrs.arrows   = angular.isDefined(attrs.arrows)   ? attrs.arrows : true;
      },
      templateUrl : 'aloengular/template/slider/slider.html'
    };
  })
  .directive('slide', function () {
    return {
      restrict    : 'EA',
      require     : '^slider',
      replace     : true,
      transclude  : true,
      scope       : {
        src : '@'
      },
      link : function ($s, $element, $a, $SliderCtrl) {
        $SliderCtrl.addSlide({ s: $s, element: $element });
      },
      templateUrl : 'aloengular/template/slider/slide.html'
    };
  })
  .directive('capt', function () {
    return {
      restrict    : 'EA',
      replace     : true,
      transclude  : true,
      scope       : {},
      templateUrl : 'aloengular/template/slider/caption.html'
    };
  })


  angular.module('aloengular/template/slider/slider.html', []).run(['$templateCache', function($templateCache) {
    $templateCache.put('aloengular/template/slider/slider.html','<div class="ang-slider" style="width : {{ width }}; height : {{ height }}"><div class="nav-inline-bullet" ng-show="{{ bullets }}"><ul><li ng-repeat="slide in slides" ng-class="{ \'active\' : slide.s.selected }" ng-click="select(slide)"></li></ul></div><div class="ang-slider-container o-h"><div class="ang-slider-section ang-swipeList" ng-transclude></div><div class="ang-slider-arrows" ng-show="{{ arrows }}"><div class="ang-slider-arrow ang-slider-arrow-left" ng-click="prev()" ng-class="{ disabled : currentIndex <= 0 }"></div><div class="ang-slider-arrow ang-slider-arrow-right" ng-click="next()" ng-class="{ disabled : currentIndex > slides.length - 2 }"></div></div></div></div>'
    );
  }]);
  angular.module('aloengular/template/slider/slide.html', []).run(['$templateCache', function($templateCache) {
    $templateCache.put('aloengular/template/slider/slide.html',
      '<div class="ang-slider-slide f-l" ng-class="{ \'ang-slider-slide-current\' : selected }" ng-transclude></div>'
    );
  }]);
  angular.module('aloengular/template/slider/caption.html', []).run(['$templateCache', function($templateCache) {
    $templateCache.put('aloengular/template/slider/caption.html',
      '<div class="ang-slider-caption" ng-transclude></div>'
    );
  }]);

})();
